export default __webpack_public_path__ + "static/media/voidco-logo02-01.887bf9b0.svg";